<template>
  <div class="brochure w100 color-white">
    <div class="page-header">
      <div class="ImageTitle font12" >FOR ILLUSTRATION ONLY</div>
    </div>
    <div class="a98b59-bg w100">
      <div class="w60 m-auto p-btm-150 p-top-150">
        <p class="Initial font21 lt10 m-btm-20 medium">MAKE YOUR FIRST MOVE TO</p>
        <p
          class="Initial font48 p-btm-50 light"
        >
          LUXURIOUS EC LIVING, REDEFINED.
        </p>
        <p class="Initial p-btm-50 regular lh35 font21">
          There are eligibility conditions to purchasing a unit at Novo Place
          EC. <br />
          Read more to understand what’s involved, including resale levy, if
          applicable.
        </p>
        <div
        @click="downFile('https://mixgovr.com/WEB/Novo-Place-EC/file/Novo Place eBrochure_Spread View (Hires).pdf')"
          class="p20 bor1 b-radius-5 m-auto flex-row content-center m-top-20 lt3 bro-down font14"
        >
          <img
          class="down-logo"
            src="@/assets/btn/down3.png"
            alt=""
          />
          DOWNLOAD ELIGIBILITY BOOKLET
        </div>
      </div>
    </div>
    <div class="f1eee6-bg w100 p-top-50 p-btm-50">
      <p class="font48 a98b59-color Initial p-btm-50 light">
        FLIP THROUGH OUR E-BROCHURE HERE
      </p>
      <div class="w60 relative m-auto">
        <!-- <swiper
          class="swiper swiperVideo w100"
          :options="swiperVideo"
          ref="swiperVideo"
        >
          <swiper-slide
            class="flex-center"
            v-for="(item, i) in brochureList"
            :key="i"
          >
            <div class="img-content w100 h100">
              <img style="object-fit: contain !important;" :src="item.path" alt="" />
              <p style="right: 0" class="color-white">
                {{ item.name }}
              </p>
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="swiper-pagination m-auto color-black"
          slot="pagination"
          style="bottom: -25px;"
        ></div>
        <div class="swiper-button-prev" style="left: -15%; top: 45%">
          <img src="@/assets/btn/left2.png" alt="" />
        </div>
        <div class="swiper-button-next" style="right: -15%; top: 45%">
          <img src="@/assets/btn/right2.png" alt="" />
        </div> -->

        <flipbook class="flipbook" :pages="broList1" v-slot="flipbook">
          <div @click="flipbook.flipLeft" class="swiper-button-prev" style="left: -15%; top: 45%">
          <img src="@/assets/btn/left2.png" alt="" />
        </div>
        <div class="swiper-button-next" style="right: -15%; top: 45%">
          <img  @click="flipbook.flipRight" src="@/assets/btn/right2.png" alt="" />
        </div>
        <div style="position: absolute;bottom: -30px;color: black;left: 50%;transform:translateX(-50%);">{{ flipbook.page }} / {{ flipbook.numPages }}</div>
        </flipbook>

      </div>
      <div
      @click="downFile('https://mixgovr.com/WEB/Novo-Place-EC/file/Novo Place eBrochure_Spread View (Hires).pdf')"
        class="p20 b-radius-5 m-auto flex-row content-center a98b59-color bro-down font14 m-top-50 lt3"
        style="border: 1px solid #a98b59;"
      >
        <img
          class="down-logo"
          src="@/assets/btn/down1.png"
          alt=""
        />
        DOWNLOAD E-BROCHURE
      </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";
import Flipbook from 'flipbook-vue/dist/vue2/flipbook.mjs'
export default {
  components: {
    Footer,
    contant,
    Flipbook
  },
  data() {
    return {
      swiperVideo: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination", //与分页器的类名绑定
          type: "fraction",
          clickable: true, // 点击分页器跳切换到相应的幻灯片(不是所有分页器都支持)
        },
        
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      broList1:[
      "",
            require("@/assets/brouchure/00.png"),
            require("@/assets/brouchure/01a.jpg"),
            require("@/assets/brouchure/01b.jpg"),
            require("@/assets/brouchure/02a.jpg"),
            require("@/assets/brouchure/02b.jpg"),
            require("@/assets/brouchure/03a.jpg"),
            require("@/assets/brouchure/03b.jpg"),
            require("@/assets/brouchure/04a.jpg"),
            require("@/assets/brouchure/04b.jpg"),
            require("@/assets/brouchure/05a.jpg"),
            require("@/assets/brouchure/05b.jpg"),
            require("@/assets/brouchure/06a.jpg"),
            require("@/assets/brouchure/06b.jpg"),
            require("@/assets/brouchure/07a.jpg"),
            require("@/assets/brouchure/07b.jpg"),
            require("@/assets/brouchure/08a.jpg"),
            require("@/assets/brouchure/08b.jpg"),
            require("@/assets/brouchure/09a.jpg"),
            require("@/assets/brouchure/09b.jpg"),
            require("@/assets/brouchure/10a.jpg"),
            require("@/assets/brouchure/10b.jpg"),
            require("@/assets/brouchure/11a.jpg"),
            require("@/assets/brouchure/11b.jpg"),
            require("@/assets/brouchure/12a.jpg"),
            require("@/assets/brouchure/12b.jpg"),
            require("@/assets/brouchure/13a.jpg"),
            require("@/assets/brouchure/13b.jpg"),
            require("@/assets/brouchure/14a.jpg"),
            require("@/assets/brouchure/14b.jpg"),
            require("@/assets/brouchure/15a.jpg"),
            require("@/assets/brouchure/15b.jpg"),
            require("@/assets/brouchure/16.png"),
      ],
      // brochureList: {
      //   0: {name: "br",path: require("@/assets/brouchure/00000.png")},
      //   1: {name: "br",path: require("@/assets/brouchure/00001.png")},
      //   2: {name: "br",path: require("@/assets/brouchure/00002.png")},
      //   3: {name: "br",path: require("@/assets/brouchure/00003.png")},
      //   4: {name: "br",path: require("@/assets/brouchure/00004.png")},
      //   5: {name: "br",path: require("@/assets/brouchure/00005.png")},
      //   6: {name: "br",path: require("@/assets/brouchure/00006.png")},
      //   7: {name: "br",path: require("@/assets/brouchure/00007.png")},
      //   8: {name: "br",path: require("@/assets/brouchure/00008.png")},
      //   9: {name: "br",path: require("@/assets/brouchure/00009.png")},
      //   10: {name: "br",path: require("@/assets/brouchure/00010.png")},
      //   11: {name: "br",path: require("@/assets/brouchure/00011.png")},
      //   12: {name: "br",path: require("@/assets/brouchure/00012.png")},
      //   13: {name: "br",path: require("@/assets/brouchure/00013.png")},
      //   14: {name: "br",path: require("@/assets/brouchure/00014.png")},
      //   15: {name: "br",path: require("@/assets/brouchure/00015.png")},
      //   16: {name: "br",path: require("@/assets/brouchure/00016.png")},
      //   17: {name: "br",path: require("@/assets/brouchure/00017.png")},
      //   18: {name: "br",path: require("@/assets/brouchure/00018.png")},
      //   19: {name: "br",path: require("@/assets/brouchure/00019.png")},
      //   20: {name: "br",path: require("@/assets/brouchure/00020.png")},
      //   21: {name: "br",path: require("@/assets/brouchure/00021.png")},
      //   22: {name: "br",path: require("@/assets/brouchure/00022.png")},
      //   23: {name: "br",path: require("@/assets/brouchure/00023.png")},
      //   24: {name: "br",path: require("@/assets/brouchure/00024.png")},
      //   25: {name: "br",path: require("@/assets/brouchure/00025.png")},
      //   26: {name: "br",path: require("@/assets/brouchure/00026.png")},
      //   27: {name: "br",path: require("@/assets/brouchure/00027.png")},
      //   28: {name: "br",path: require("@/assets/brouchure/00028.png")},
      //   29: {name: "br",path: require("@/assets/brouchure/00029.png")},
      //   30: {name: "br",path: require("@/assets/brouchure/00030.png")},
      //   31: {name: "br",path: require("@/assets/brouchure/00031.png")},
      // },
    };
  },
  methods: {
    downFile(url){
      window.open(url)
    }
  },
};
</script>

<style lang="less">
.brochure {
  .flipbook {
  width: 100%;
  height: 90vh;
  }
  margin-top: -56px;
  .page-header {
    height: calc(100vh - 110px);
    background-image: url("~@/assets/brouchure/Novo_Family Home_RGB_lr.jpg");
    background-size: cover;
    background-position-y: 78%;
    position: relative;
  }
  .bro-down{
    width: 400px;
    align-items: center;
  }
  .down-logo{
    width: 25px;
    height: 25px;
    margin-right: 20px
  }

  .swiperVideo {
    height: 75vh;
  }
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 2rem;
      max-width: 2rem;
    }
  }
}


@media (max-width: 900px) {
  .brochure{
    .page-header{
      height: 30vh;
    }
    .flipbook{
      height: 55vh;
    }
  }


  .bro-down{
    width: 80% !important;
    font-size: 7px !important;
  }
  .down-logo{
    width: 20px !important;
    height: 20px !important;
    margin-right: 10px !important;
  }
  .swiperVideo {
    height: 45vh !important;
  }
  .swiper-button-prev,
  .swiper-button-next{
    display: none !important;
  }

}




</style>











